package com.vizio.redwolf.auth.utils

import com.vizio.redwolf.utils.ResponseHeaders
import com.vizio.redwolf.utils.model.PayFailureResponse
import kotlin.js.JsExport

@JsExport
sealed class ARValidationResult {
    class SuccessValid : ARValidationResult()
    data class SuccessAllTokensUpdated(val newAccessToken: String, val newAccessTokenExpiry: String, val newRefreshToken: String, val reason: TokenRefreshReason) : ARValidationResult()
    data class NeedsReLogin(val headers: ResponseHeaders, val failureResponse: PayFailureResponse) : ARValidationResult()
    data class Failed(val headers: ResponseHeaders, val failureResponse: PayFailureResponse) : ARValidationResult()
    data class Error(val headers: ResponseHeaders, val exception: Throwable) : ARValidationResult()
    data class Timeout(val headers: ResponseHeaders, val exception: Throwable) : ARValidationResult()

    fun <R> fold(
        onSuccessValid: (successValid: SuccessValid) -> R,
        onSuccessAllTokensUpdated: (successUpdateAll: SuccessAllTokensUpdated) -> R,
        onNeedsReLogin: (needsReLogin: NeedsReLogin) -> R,
        onFailed: (failed: Failed) -> R,
        onError: (error: Error) -> R,
        onTimeout: (timeout: Timeout) -> R
    ): R {
        return when (this) {
            is SuccessValid -> onSuccessValid(SuccessValid())
            is SuccessAllTokensUpdated -> onSuccessAllTokensUpdated(SuccessAllTokensUpdated(this.newAccessToken, this.newAccessTokenExpiry, this.newRefreshToken, this.reason))
            is NeedsReLogin -> onNeedsReLogin(NeedsReLogin(this.headers, this.failureResponse))
            is Failed -> onFailed(Failed(this.headers, this.failureResponse))
            is Error -> onError(Error(this.headers, this.exception))
            is Timeout -> onTimeout(Timeout(this.headers, this.exception))
        }
    }
}
